module.exports = __webpack_public_path__ + "static/media/Vaginal-Contraceptive-Ring-first-lithonia-medical-center.cd938f37.jpg";